import * as AskForRateLoadingInformation from './ask-for-rate-loading-information/ask-for-rate-loading-information.ctrl'
import * as askToConfirmRfpContract from './ask-to-confirm-rfp-contract/ask-to-confirm-rfp-contract';

export { Dialogs as default }

Dialogs.$inject = ['rbDialogProvider'];
function Dialogs(rbDialogProvider) {
  rbDialogProvider
    .add(AskForRateLoadingInformation.NAME, AskForRateLoadingInformation.HTML, AskForRateLoadingInformation.Controller)
    .add(askToConfirmRfpContract.NAME, askToConfirmRfpContract.HTML, askToConfirmRfpContract.Controller)
}
